import { cn } from "../../utils";

interface GuidancePromptProps {
    type: "mode_selection" | "use_case_suggestion" | "clarify_zero_hit";
    suggestions: Array<{
        label: string;
        description?: string;
        query?: string;
    }>;
    onSelect: (selection: { label: string; query?: string }) => void;
    disabled?: boolean;
}

export function GuidancePrompt({ type, suggestions, onSelect, disabled }: GuidancePromptProps) {
    if (suggestions.length === 0) return null;

    const heading =
        type === "mode_selection"
            ? "この質問は以下のどちらに関連していますか？"
            : type === "clarify_zero_hit"
                ? "もう少し詳しく教えてください"
                : "何を知りたいですか？";

    return (
        <div style={{ marginTop: '6px', width: '100%', borderRadius: '8px', border: '1px solid #bfdbfe', backgroundColor: 'rgba(239, 246, 255, 0.8)', padding: '10px' }}>
            {type === "mode_selection" ? (
                <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                    <p className="font-semibold text-blue-900" style={{ fontSize: '14px', margin: 0 }}>
                        {heading}
                    </p>
                    <div style={{ display: 'flex', flexDirection: 'row', gap: '6px' }}>
                        {suggestions.map((sug, idx) => (
                            <button
                                key={idx}
                                type="button"
                                disabled={disabled}
                                onClick={() => onSelect({ label: sug.label })}
                                className={cn(
                                    "flex flex-1 flex-col items-start rounded-md border-2 border-blue-300 bg-white p-2 text-left transition",
                                    "hover:border-blue-500 hover:bg-blue-50",
                                    "disabled:opacity-50 disabled:cursor-not-allowed"
                                )}
                                style={{ gap: '2px' }}
                            >
                                <span className="font-semibold text-blue-900" style={{ fontSize: '14px' }}>{sug.label}</span>
                                {sug.description && (
                                    <span className="text-blue-700" style={{ fontSize: '12px' }}>{sug.description}</span>
                                )}
                            </button>
                        ))}
                    </div>
                </div>
            ) : (
                <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                    <p className="font-semibold text-blue-900" style={{ fontSize: '14px', margin: 0 }}>{heading}</p>
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '6px', margin: 0 }}>
                        {suggestions.map((sug, idx) => (
                            <button
                                key={idx}
                                type="button"
                                disabled={disabled}
                                onClick={() => onSelect({ label: sug.label, query: sug.query })}
                                style={{
                                    margin: 0,
                                    fontSize: '13px',
                                    borderRadius: '6px',
                                    border: '1px solid #93c5fd',
                                    backgroundColor: '#ffffff',
                                    padding: '6px 8px',
                                    fontWeight: 500,
                                    color: '#1e3a8a',
                                    cursor: 'pointer',
                                    transition: 'all 0.15s',
                                }}
                            >
                                {sug.label}
                            </button>
                        ))}
                    </div>
                    {type === "clarify_zero_hit" && (
                        <p className="text-blue-700" style={{ fontSize: '12px', margin: 0 }}>
                            例: 施設名＋入院料、条番号、届出書式など具体的なキーワードを入れるとヒットしやすくなります。
                        </p>
                    )}
                </div>
            )}
        </div>
    );
}
